import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import { Children, FC, MouseEvent, ReactNode, useCallback } from 'react'
import SwipeableViews from 'react-swipeable-views'

import { TabPanel } from '../Tabs/TabPanel'

type SegmentProps = {
  labels: string[]
  value: number
  onChange: (value: number) => void
  children: ReactNode[]
  hiddenLabel?: boolean
  disableAnimateTransitions?: boolean
}

export const Segment: FC<SegmentProps> = ({
  labels,
  value,
  onChange,
  children,
  hiddenLabel,
  disableAnimateTransitions,
}) => {
  const handleChange = useCallback(
    (event: MouseEvent<HTMLElement>, newValue: number | null) => {
      if (newValue === null) {
        return
      }
      onChange(newValue)
    },
    [onChange]
  )

  return (
    <Box>
      {!hiddenLabel && (
        <ToggleButtonGroup
          value={value}
          fullWidth
          exclusive
          sx={{ pt: 2, pb: 4 }}
          onChange={handleChange}
        >
          {labels.map((label, index) => (
            <ToggleButton
              key={index}
              value={index}
              sx={{
                py: 1,
                borderRadius: 1,
                border: 'none',
                bgcolor: 'grey.50',
                '&.Mui-selected': {
                  bgcolor: 'grey.100',
                },
              }}
            >
              <Typography
                variant="subtitle1"
                color={value === index ? 'text.primary' : 'text.hint'}
              >
                {label}
              </Typography>
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      )}
      <SwipeableViews
        index={value}
        onChangeIndex={onChange}
        disabled={hiddenLabel}
        animateTransitions={!(hiddenLabel || disableAnimateTransitions)}
      >
        {Children.map(children, (child, index) => (
          <TabPanel index={index} value={value} key={index}>
            {child}
          </TabPanel>
        ))}
      </SwipeableViews>
    </Box>
  )
}
